module.exports = __webpack_public_path__ + "static/media/student4.d64c4f3e.png";